import { stringify, parse } from "flatted"

import { DBDefaults } from "../defines/values"
import { TapestryMap } from "../map/tapestrymap"
import { Player } from "../player/player"
import { Tapestry } from "../popup/tapestry"

export function clearLocalStorage(): void {
  localStorage.removeItem(DBDefaults.KEY_TAPESTRY)
  localStorage.removeItem(DBDefaults.KEY_PLAYER)
}

export function dbRetrievePlayer(
  key: string = DBDefaults.KEY_PLAYER
): Player | undefined {
  const json = localStorage.getItem(key)
  if (json) {
    return parse(json)
  }

  return undefined
}

export function dbRetrieveTapestry(
  key: string = DBDefaults.KEY_TAPESTRY
): Tapestry | undefined {
  const json = localStorage.getItem(key)
  if (json) {
    return parse(json)
  }

  return undefined
}

export function dbStore(key: string, object: any): void {
  localStorage.setItem(key, stringify(object))
}

export function deletePlayerStore(key: string = DBDefaults.KEY_PLAYER): void {
  localStorage.removeItem(key)
}
